module.exports = __webpack_public_path__ + "img/22.f7938717.jpg";